<script>
// Renders a scoped-slot function that was passed in as a plain prop.
//
// Needed when a child component must render a slot that its parent forwarded as
// a prop instead of an actual slot — e.g. rows rendered by vue3-virtual-scroll-list,
// which renders each row through `data-component`/`extra-props` and never forwards
// the parent's slots.
export default {
  name: 'AppSlotOutlet',
  props: {
    slotFn: {
      type: Function,
      default: null,
    },
    scope: {
      type: Object,
      default: () => ({}),
    },
  },
  render() {
    return typeof this.slotFn === 'function' ? this.slotFn(this.scope) : null;
  },
};
</script>
